'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var hooks = require('@travpro/hooks');
var _TextField = require('@mui/material/TextField');
var _InputLabel = require('@mui/material/InputLabel');
var web = require('@react-spring/web');
var _FormControl = require('@mui/material/FormControl');
var _RadioGroup = require('@mui/material/RadioGroup');
var _FormControlLabel = require('@mui/material/FormControlLabel');
var _Radio = require('@mui/material/Radio');
var _FormLabel = require('@mui/material/FormLabel');
var _Select = require('@mui/material/Select');
var _MenuItem = require('@mui/material/MenuItem');
var _Typography = require('@mui/material/Typography');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _TextField__default = /*#__PURE__*/_interopDefaultLegacy(_TextField);
var _InputLabel__default = /*#__PURE__*/_interopDefaultLegacy(_InputLabel);
var _FormControl__default = /*#__PURE__*/_interopDefaultLegacy(_FormControl);
var _RadioGroup__default = /*#__PURE__*/_interopDefaultLegacy(_RadioGroup);
var _FormControlLabel__default = /*#__PURE__*/_interopDefaultLegacy(_FormControlLabel);
var _Radio__default = /*#__PURE__*/_interopDefaultLegacy(_Radio);
var _FormLabel__default = /*#__PURE__*/_interopDefaultLegacy(_FormLabel);
var _Select__default = /*#__PURE__*/_interopDefaultLegacy(_Select);
var _MenuItem__default = /*#__PURE__*/_interopDefaultLegacy(_MenuItem);
var _Typography__default = /*#__PURE__*/_interopDefaultLegacy(_Typography);

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var propTypes = {exports: {}};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

/**
 * @typedef ConditionalFormContextValue
 * @property {Object<string>} formData Internal form data
 * @property {React.Dispath} setFormData Form data update function
 */

/** @type {ConditionalFormContextValue} */

const defaultContextValue = {
  formData: {},
  setFormData: () => undefined
};
const ConditionalFormContext = /*#__PURE__*/React.createContext(defaultContextValue);
var useConditionalForm = (() => React.useContext(ConditionalFormContext));
/**
 * @typedef {object} ConditionalFormContextProviderProps
 * @property {JSX.Element} children Children To pass context to
 */

/**
 * Provides form data to its consumers
 *
 * @param {ConditionalFormContextProviderProps} props Props
 * @returns {React.Context} React context element
 */

const ConditionalFormContextProvider = ({
  children
}) => {
  const [value, setValue] = React.useState({ ...defaultContextValue
  });
  const setFormData = React.useCallback(data => {
    if (Object.keys(data).length === 0) {
      setValue(prev => ({ ...prev,
        formData: {}
      }));
      return;
    }

    setValue(prev => ({ ...prev,
      formData: { ...prev.formData,
        ...data
      }
    }));
  }, [setValue]);
  const getContext = React.useCallback(() => ({ ...value,
    setFormData
  }), [value, setFormData]);
  return /*#__PURE__*/React__default["default"].createElement(ConditionalFormContext.Provider, {
    value: getContext()
  }, children);
};
ConditionalFormContextProvider.propTypes = {
  children: propTypes.exports.oneOfType([propTypes.exports.node, propTypes.exports.arrayOf(propTypes.exports.node)]).isRequired
};
ConditionalFormContextProvider.defaultProps = {};

/**
 * Form that keeps track of ConditionalInput data
 *
 * @param {object} props Props
 * @param {Function} props.onSubmit Function called when form is submitted
 * @param {Function} props.onChange Function called when form data is updated
 * @param {React.JSX} props.children Form content
 * @returns {HTMLFormElement} ConditionalForm component
 * @preserve
 */

const ConditionalForm = ({
  onSubmit,
  onChange,
  children
}) => {
  const c = hooks.useClassName('conditionalForm');
  const {
    formData
  } = useConditionalForm();
  React.useEffect(() => onChange(formData), [onChange, formData]);
  const submitHandler = React.useCallback(e => {
    e.preventDefault();
    const inputs = Array.from(e.target.querySelectorAll('input'));
    const fieldValidation = inputs.map(child => child.checkValidity());

    if (fieldValidation.every(field => field === true)) {
      onSubmit(e, formData);
    }
  }, [formData, onSubmit]);
  return /*#__PURE__*/React__default["default"].createElement("form", _extends({}, c(), {
    onSubmit: submitHandler
  }), children);
};

var ConditionalForm$1 = (({
  children,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(ConditionalFormContextProvider, null, /*#__PURE__*/React__default["default"].createElement(ConditionalForm, props, children)));
ConditionalForm.propTypes = {
  children: propTypes.exports.oneOfType([propTypes.exports.node, propTypes.exports.arrayOf(propTypes.exports.node)]).isRequired,
  onSubmit: propTypes.exports.func,
  onChange: propTypes.exports.func
};
ConditionalForm.defaultProps = {
  onSubmit: () => undefined,
  onChange: () => undefined
};

const RadioGroup = ({
  id,
  label: formLabel,
  onChange,
  options,
  value: formValue
}) => /*#__PURE__*/React__default["default"].createElement(_FormControl__default["default"], null, formLabel && /*#__PURE__*/React__default["default"].createElement(_FormLabel__default["default"], {
  id: [id, 'label'].join('-')
}, formLabel), /*#__PURE__*/React__default["default"].createElement(_RadioGroup__default["default"], {
  name: id,
  onChange: e => onChange(e),
  value: formValue
}, options.map(({
  value,
  label
}) => /*#__PURE__*/React__default["default"].createElement(_FormControlLabel__default["default"], {
  key: label,
  value: value,
  label: label,
  control: /*#__PURE__*/React__default["default"].createElement(_Radio__default["default"], null)
}))));
RadioGroup.propTypes = {
  id: propTypes.exports.string.isRequired,
  label: propTypes.exports.string,
  onChange: propTypes.exports.func,
  options: propTypes.exports.arrayOf(propTypes.exports.shape({
    value: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
    label: propTypes.exports.string
  })),
  value: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number])
};
RadioGroup.defaultProps = {
  label: undefined,
  onChange: () => undefined,
  options: [],
  value: undefined
};

const SelectGroup = ({
  id,
  options,
  label: formLabel,
  value: formValue = '',
  onChange,
  inputLabel
}) => {
  const labelId = [id, inputLabel || formLabel].join('-');
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, formLabel && /*#__PURE__*/React__default["default"].createElement(_Typography__default["default"], null, formLabel), /*#__PURE__*/React__default["default"].createElement(_FormControl__default["default"], {
    fullWidth: true
  }, inputLabel && /*#__PURE__*/React__default["default"].createElement(_InputLabel__default["default"], {
    id: labelId
  }, inputLabel), /*#__PURE__*/React__default["default"].createElement(_Select__default["default"], {
    labelId: labelId,
    value: formValue,
    label: inputLabel || formLabel,
    onChange: onChange
  }, options.map(({
    value,
    label
  }) => /*#__PURE__*/React__default["default"].createElement(_MenuItem__default["default"], {
    key: label,
    value: value
  }, label)))));
};
SelectGroup.propTypes = {
  inputLabel: propTypes.exports.string,
  id: propTypes.exports.string.isRequired,
  label: propTypes.exports.string,
  onChange: propTypes.exports.func,
  options: propTypes.exports.arrayOf(propTypes.exports.shape({
    label: propTypes.exports.string,
    value: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number])
  })),
  value: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number])
};
SelectGroup.defaultProps = {
  inputLabel: undefined,
  label: undefined,
  onChange: () => undefined,
  options: [],
  value: undefined
};

/**
 * Fires when form input validation fails, second parameter is a state setter to set the input's helper text
 *
 * @typedef {(
 *   e: React.FormEvent<HTMLDivElement>,
 *   setHelperText: React.Dispatch<(prevState: undefined) => undefined>,
 * ) => void} onInvalid
 */

/**
 * @typedef {object} ConditionalInputProps
 * @property {import('@react-spring/web').UseTransitionProps} animation Properties for the transition on where change
 * @property {string} id Identifier for the input element within the form
 * @property {string} inputLabel Text label for the select input element, same as label unless specified
 * @property {string} label Text label for the input element
 * @property {React.ChangeEventHandler} onChange Function to run on change
 * @property {onInvalid} onInvalid Function called when text input validation fails
 * @property {{ value: string | number; label: string }[]} options Array of options for the radio and select elements
 * @property {React.HTMLInputTypeAttribute | 'select'} type Input type
 * @property {boolean} validateOnBlur Call validation function on text field blur
 * @property {Function} onBlur Call custom function on element blur
 * @property {Function | boolean} where Conditional to determine whether or not input should render
 */

/**
 * @param {ConditionalInputProps} props Props
 * @returns {JSX.Element} Condition input element
 */

const ConditionalInput = ({
  animation,
  id,
  inputLabel,
  label,
  onBlur,
  onChange,
  onInput,
  onInvalid,
  options: rawOptions,
  required,
  type,
  validate,
  validateOnBlur,
  where,
  ...props
}) => {
  const [helperText, setHelperText] = React.useState();
  const c = hooks.useClassName('conditionalInput');
  const {
    formData,
    setFormData
  } = useConditionalForm();
  let shouldRender = where;
  let options = rawOptions;
  if (typeof where === 'function') shouldRender = where(formData);
  if (typeof rawOptions === 'function') options = rawOptions(formData);
  const transitions = web.useTransition(shouldRender, animation);
  const updateForm = React.useCallback(e => {
    if (formData[id] !== e.target.value) {
      setFormData({
        [id]: e.target.value.length > 0 ? e.target.value : undefined
      });
    }

    onChange(e);
  }, [formData, id, onChange, setFormData]);
  const validateInput = React.useCallback((e, data) => {
    e.preventDefault();
    const validationMessage = validate(e, data);

    if (validationMessage !== false) {
      e.target.setCustomValidity(validationMessage);
      e.target.reportValidity();
    } else {
      e.target.setCustomValidity('');
      e.target.checkValidity();
      e.target.reportValidity();
    }

    if (e.target.checkValidity() && helperText && helperText.length > 0) {
      setHelperText();
    }
  }, [helperText, validate]);
  React.useEffect(() => {
    if (shouldRender === false && formData[id] !== undefined) {
      setHelperText();
      setFormData({
        [id]: undefined
      });
    }
  }, [formData, id, setFormData, shouldRender]);
  return transitions((style, render) => render ? /*#__PURE__*/React__default["default"].createElement(web.animated.div, _extends({
    key: render,
    style: style
  }, c({
    type
  })), type === 'radio' && options.length > 0 && /*#__PURE__*/React__default["default"].createElement(RadioGroup, {
    id: id,
    label: label,
    onChange: updateForm,
    options: options,
    value: formData[id] || null
  }), type === 'select' && options.length > 0 && /*#__PURE__*/React__default["default"].createElement(SelectGroup, {
    id: id,
    label: label,
    onChange: updateForm,
    options: options,
    value: formData[id],
    inputLabel: inputLabel || label
  }), ['text', 'email', 'password'].includes(type) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, label && /*#__PURE__*/React__default["default"].createElement(_InputLabel__default["default"], {
    htmlFor: id
  }, label), /*#__PURE__*/React__default["default"].createElement(_TextField__default["default"], _extends({
    id: id,
    type: type,
    onInput: e => {
      const data = { ...formData,
        [id]: e.target.value
      };
      updateForm(e);
      onInput(e, data);

      if (validate) {
        validateInput(e, data);
      }
    },
    error: helperText && helperText.length > 0 || undefined,
    helperText: helperText,
    onInvalid: e => {
      e.preventDefault();

      if (validate) {
        onInvalid(e, setHelperText);
      } else {
        e.target.reportValidity();
      }
    },
    onBlur: e => {
      if (validateOnBlur) {
        validateInput(e, formData);
      }

      if (onBlur) onBlur(e, formData);
    },
    required: required
  }, props)))) : null);
};
ConditionalInput.propTypes = {
  animation: propTypes.exports.shape({
    from: propTypes.exports.shape(),
    enter: propTypes.exports.shape(),
    leave: propTypes.exports.shape()
  }),
  id: propTypes.exports.string.isRequired,
  inputLabel: propTypes.exports.string,
  label: propTypes.exports.string,
  onInput: propTypes.exports.func,
  onBlur: propTypes.exports.func,
  onChange: propTypes.exports.func,
  onInvalid: propTypes.exports.func,
  options: propTypes.exports.oneOfType([propTypes.exports.func, propTypes.exports.arrayOf(propTypes.exports.string), propTypes.exports.arrayOf(propTypes.exports.shape({
    value: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
    label: propTypes.exports.string
  }))]),
  type: propTypes.exports.oneOf(['checkbox', 'email', 'file', 'image', 'input', 'number', 'password', 'select', 'radio', 'range', 'text', 'time']),
  validate: propTypes.exports.func,
  validateOnBlur: propTypes.exports.bool,
  where: propTypes.exports.oneOfType([propTypes.exports.func, propTypes.exports.bool])
};
ConditionalInput.defaultProps = {
  animation: {
    enter: {
      opacity: 1,
      position: 'unset'
    },
    from: {
      opacity: 0,
      position: 'absolute'
    },
    leave: {
      opacity: 0,
      position: 'absolute'
    }
  },
  inputLabel: undefined,
  label: undefined,
  onInput: () => undefined,
  onBlur: () => undefined,
  onChange: () => undefined,
  onInvalid: (e, setHelperText) => {
    setHelperText(e.target.validationMessage);
  },
  options: [],
  required: false,
  type: 'text',
  validate: () => false,
  validateOnBlur: true,
  where: true
};

exports.ConditionalForm = ConditionalForm$1;
exports.ConditionalInput = ConditionalInput;
exports.useConditionalForm = useConditionalForm;
//# sourceMappingURL=index.js.map
